<template lang="html">
  <div class="" id="" v-if="startup ">
    <UpdateNonStartup :what="what" :dict="dict" :dialogVisible="dialog.summary_update" :s="to_edit_startup" @close="closeAndReset()" @confirmed="confirmEdit($event)" />
    <ConnectedSoonModal v-if="startup.linkplus" :dialogVisible="showSoonModal" :sid="startup._id.$oid" @close="showSoonModal = false" :client_name="partner_client_name" :who="startup.name" @confirmed="data_policy_start" />
    <ConnectedOkModal v-if="startup.linkplus" :dialogVisible="showConnectedOKModal" @close="showConnectedOKModal = false" />

    <AddComment :dialogVisible='showSubmitModal' @close="showSubmitModal = false" @newValueIsProposed="realSubmit($event)"/>
    <div class=" ">
      <div class="headerStartup">
        <div class="partialInfo" v-if="startup.partial == true">
            <span class="">Your profile is not submitted yet !</span>
        </div>
        <div class="col-12 startup_banner" >
             <img :src="this.apiUrl+'/get_image/'+startup_image+'?token='+$store.state.innotoken" alt="" class="" v-if="startup_image">
             <div class="fallbackBanner" v-else>
              <img :src="require('@/assets/defban.jpg')" alt=""/>
             </div>
              <div class="changeImage" v-if=" startup._id">
                <button type="button" name="button" @click='$refs.bannerUp.focus();$refs.bannerUp.click();'>
                    <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>
                </button>
                <input type="file" ref="bannerUp" name="bannerUp" id="bannerUp" @change="selectBanner" accept="image/*"/>
               </div>
               <div class="row uploadProceedBanner" v-if="uploadProceedBanner">
                 <div class="col-12 text-center uploadProcess">
                     <span class="progressText">Upload in progress. Please wait a moment.</span>
                   <v-progress-linear
                     v-model="progress"
                     color="blue-grey"
                     height="25"
                   >
                 </v-progress-linear>

                 </div>

               </div>
        </div>

        <div class="startup_logo">
          <div class="startup_logo_inside">
            <div class="" v-if="startup_logo">
              <img :src="this.apiUrl+'/get_image/'+startup_logo+'?token='+$store.state.innotoken" alt="" class="" v-if="startup_logo">

            </div>
            <div class="alt" v-else>
              <img :src="require('@/assets/logodef.jpg')" alt="" />

            </div>
            <div class="changeImageLogo" v-if=" startup._id">
               <button type="button" name="button" @click='$refs.logoUp.focus();$refs.logoUp.click();'>
                   <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>
               </button>
               <input type="file" ref="logoUp" name="logoUp" id="logoUp" @change="selectLogo" accept="image/*"/>
              </div>
              <div class="row uploadProceedBanner" v-if="uploadProceedLogo">
                <div class="col-12 text-center uploadProcess">
                    <span class="progressText">Upload in progress. Please wait a moment.</span>
                  <v-progress-linear
                    v-model="progress"
                    color="blue-grey"
                    height="25"
                  >
                </v-progress-linear>

                </div>

              </div>
          </div>

        </div>

      </div>



      <div class="content_div mt100 " v-if="startup">
        <div class="needHelp">
            <a @click="showEditModal('needhelp')">
               <span> Need help ?</span>
             </a>
        </div>
          <div class="row dflex revese pl20">

            <div class="col-12 col-lg-6 col-xl-8 force50 force100">
              <h5 class="tblue"><strong>Summary</strong>
                <button type="button" name="button" class="editField" @click="showEditModal('summary')">
                  <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>
                 </button>
               </h5>

              <StartupInfoLine v-if="startup.company_type" class="noBorder" className="inHeader" name="Company type" :value="startup.company_type" />
              <StartupInfoLine v-else name="Company type" class="noBorder" className="inHeader" value="No data" />


              <StartupInfoLine v-if="startup.application_area" class="noBorder" className="inHeader" name="Application domain" :value="startup.application_area"  :isArray="Array.isArray(startup.application_area)"/>
              <StartupInfoLine v-else name="Application domain" class="noBorder" className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.value_proposition" class="noBorder" className="inHeader" name="Value proposition" :value="startup.value_proposition"  :isArray="Array.isArray(startup.value_proposition)"/>
              <StartupInfoLine v-else name="Value proposition" class="noBorder" className="inHeader" value="No data" />

              <StartupInfoLine v-if="startup.solution" name="solution" className="inHeader" class="noBorder" :value="startup.solution"/>
              <StartupInfoLine v-else name="solution" class="noBorder" className="inHeader" value="No data" />

                <StartupInfoLine v-if="startup.location" class="noBorder" className="inHeader" name="Location" :isLocation="true" :value="startup.location" :isArray="Array.isArray(startup.location)"/>
                <StartupInfoLine v-else name="Location"  class="noBorder" className="inHeader" value="No data" />

            </div>
            <div class="col-12 col-lg-6 col-xl-4 force50">
              <h5 class="tdore fs30 text-center"><strong>{{startup.name}}</strong></h5>
              <div class="contactZone mt20" v-if="startup.key_contact_name || startup.key_contact_email || startup.website">
                <button type="button" name="button" class="editContact" @click="showEditModal('contacts')">
                  <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>

                </button>
                <div class="mb20 dflexcontact">
                  <div class="contactIcon"><v-icon icon="mdi:mdi-account-circle-outline" /></div>
                  <div class="">
                    <h5><strong>Key contact</strong></h5>
                    <span class="contactInfo_kcn" v-if="startup.key_contact_name">{{startup.key_contact_name}}</span>
                  </div>

                </div>

                  <ul class="contactInfoList">
                    <li class="contactInfoItem" v-if="startup.key_contact_email">
                      <a :href="'mailto:'+startup.key_contact_email">{{startup.key_contact_email}}</a>
                    </li>
                    <li class="contactInfoItem" v-if="startup.key_contact_phone">
                      <a :href="'tel:'+startup.key_contact_phone">{{startup.key_contact_phone}}</a>
                    </li>
                    <li class="contactInfoItem" v-if="startup.website">
                      <a :href="website_formated" target="_blank">{{ getBaseUrl(startup.website) }}</a>
                    </li>

                  </ul>
              </div>
            </div>
          </div>


          <div class="row mt50">
            <div class="col-12 " v-if="startup">


              <v-tabs v-model="tab" bg-color="primary" align-tabs="center" show-arrows center-active>
                <v-tab value="company">Company</v-tab>
                <v-tab value="contact">Contact</v-tab>
                <v-tab value="capabilities">Capabilities</v-tab>
                <v-tab value="solution">Solution</v-tab>
                <v-tab value="traction">Traction</v-tab>
                <v-tab value="goals">Goals</v-tab>
              </v-tabs>
              <v-window v-model="tab">
                <v-window-item value="company">
                  <button type="button" name="button" class="editContact" @click="showEditModal('company')">
                    <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>

                  </button>
                  <div class="row padding20 insideTab">
                    <div class="grid">
                      <StartupInfoLine :noCutter='true' v-if="startup.name" name="Organization name" :value="startup.name" />
                      <StartupInfoLine :noCutter='true' v-if="startup.website" name="Website" :value="startup.website" :isUrl="true"/>

                      <StartupInfoLine :noCutter='true' v-if="startup.location" name="Location" :value="startup.location" :isLocation="true" :isArray="Array.isArray(startup.location)"/>

                      <StartupInfoLine :noCutter='true' v-if="startup.linkedin_profile" name="Linkedin profile" :value="startup.linkedin_profile" :isUrl="true"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.calendar_link" name="Calendar link" :value="startup.calendar_link" :isUrl="true"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.lastEditDate" name="Last modification" :value="startup.lastEditDate" :isDate="true" />

                    </div>
                  </div>
                </v-window-item>


                <v-window-item value="contact">
                  <button type="button" name="button" class="editContact"  @click="showEditModal('contacts')">
                    <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>

                  </button>
                  <div class="row padding20 insideTab">
                    <div class="siline undefined">
                      <div class="info_startup " v-if="startup.key_contact_name">
                        <div  class="info_startup_1">
                          <span  class="info_name undefined">Key contact</span>
                        </div>
                        <div class="info_startup_2">
                        <span class="info_value">
                          <div class="listOfContacts" >

                          <div class="contactZone " v-if="startup.key_contact_name">
                            <div class="mb20 dflexcontact">
                              <div class="contactIcon"><v-icon icon="mdi:mdi-account-circle-outline" /></div>
                              <div class="">
                                <h5><strong>{{startup.key_contact_name}}</strong></h5>
                                <span class="contactInfo_kcn" v-if="startup.key_contact_role">{{startup.key_contact_role}}</span>
                              </div>

                            </div>

                              <ul class="contactInfoList">
                                <li class="contactInfoItem" v-if="startup.key_contact_email">
                                  <a :href="'mailto:'+startup.key_contact_email">{{startup.key_contact_email}}</a>
                                </li>
                                <li class="contactInfoItem" v-if="startup.key_contact_phone">
                                  <a :href="'tel:'+startup.key_contact_phone">{{startup.key_contact_phone}}</a>
                                </li>

                              </ul>
                              <div class="clinks">
                                <a v-if="founderLink(startup.key_contact_calendar_link)" :href="founderLink(startup.key_contact_calendar_link)" target="_blank" class="picto_link_linkedin"><v-icon class="tblue" icon="mdi:mdi-calendar-clock" style="font-size: 20px;"/></a>

                                <a v-if="founderLink(startup.key_contact_linkedin)" :href="founderLink(startup.key_contact_linkedin)" target="_blank" class="picto_link_linkedin"><v-icon class="tblue" icon="mdi:mdi-linkedin" style="font-size: 20px;"/></a>

                              </div>
                          </div>

                        </div>

                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="info_startup " v-if="isThereFounders(startup.contacts)">
                    <div  class="info_startup_1">
                      <span  class="info_name undefined">Other contacts</span>
                    </div>
                    <div class="info_startup_2">



                      <div class="listOfContacts" v-if="isThereFounders(startup.contacts)">
                        <!-- <table class="table">
                          <tbody>
                            <tr class="respTable" v-for='(f,i) in startup.contacts' :key="i">
                              <td>   {{f.name}} </td>
                              <td >   {{f.position}} </td>
                              <td >    <span v-if="f.phone">
                                           <v-icon icon="mdi:mdi-phone" style="font-size: 18px;"/>
                                           {{f.phone}}
                                         </span></td>
                              <td >
                                <span v-if="f.email">
                                       <v-icon icon="mdi:mdi-at" style="font-size: 18px;"/> {{f.email}}
                                  </span>

                            </td>
                              <td class="text-right" >
                                <a v-if="founderLink(f.calendar_link)" :href="founderLink(f.calendar_link)" target="_blank" class="picto_link_linkedin"><v-icon class="tblue" icon="mdi:mdi-calendar-clock" style="font-size: 20px;"/></a>
                            </td>
                              <td class="text-right" >
                                <a v-if="founderLink(f.linkedin_profile)" :href="founderLink(f.linkedin_profile)" target="_blank" class="picto_link_linkedin"><v-icon class="tblue" icon="mdi:mdi-linkedin" style="font-size: 20px;"/></a>
                            </td>

                            </tr>
                          </tbody>

                        </table> -->
                        <div class="contactZone " v-for='(f,i) in startup.contacts' :key="i">
                          <div class="mb20 dflexcontact">
                            <div class="contactIcon"><v-icon icon="mdi:mdi-account-circle-outline" /></div>
                            <div class="">
                              <h5><strong>{{f.name}}</strong></h5>
                              <span class="contactInfo_kcn" v-if="f.position">{{f.position}}</span>
                            </div>

                          </div>

                            <ul class="contactInfoList">
                              <li class="contactInfoItem" v-if="f.email">
                                <a :href="'mailto:'+f.email">{{f.email}}</a>
                              </li>
                              <li class="contactInfoItem" v-if="f.phone">
                                <a :href="'tel:'+f.phone">{{f.phone}}</a>
                              </li>

                            </ul>
                            <div class="clinks">
                              <a v-if="founderLink(f.calendar_link)" :href="founderLink(f.calendar_link)" target="_blank" class="picto_link_linkedin"><v-icon class="tblue" icon="mdi:mdi-calendar-clock" style="font-size: 20px;"/></a>

                              <a v-if="founderLink(f.linkedin_profile)" :href="founderLink(f.linkedin_profile)" target="_blank" class="picto_link_linkedin"><v-icon class="tblue" icon="mdi:mdi-linkedin" style="font-size: 20px;"/></a>

                            </div>
                        </div>


                      </div>
                      </div>
                  </div>
                </div>
                </v-window-item>

                <v-window-item value="capabilities">
                  <button type="button" name="button" class="editContact"  @click="showEditModal('capabilities')">
                    <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>

                  </button>
                  <div class="row padding20 insideTab">
                    <div class="grid">
                      <StartupInfoLine :noCutter='true' v-if="startup.IP" name="ip" :value="startup.IP" :isArray="Array.isArray(startup.IP)"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.skills" name="Skills" :value="startup.skills" :isArray="Array.isArray(startup.skills)"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.assets" name="Assets" :value="startup.assets" :isArray="Array.isArray(startup.assets)"/>

                    </div>
                  </div>
                </v-window-item>


                <v-window-item value="solution">
                  <button type="button" name="button" class="editContact" @click="showEditModal('solution')">
                    <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>

                  </button>
                  <div class="row padding20 insideTab">
                    <div class="grid">
                      <StartupInfoLine :noCutter='true' v-if="startup.value_proposition" name="Value proposition" :value="startup.value_proposition"  :isArray="Array.isArray(startup.value_proposition)"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.product_category" name="Innovation category" :value="startup.product_category" :isArray="Array.isArray(startup.product_category)"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.innovation_area" name="Innovation Area" :value="startup.innovation_area" :isArray="Array.isArray(startup.innovation_area)"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.solution" name="solution" :value="startup.solution"/>

                      <!-- NEW FIELD -->
                      <StartupInfoLine :noCutter='true' v-if="startup.data_available" name="Data available" :value="startup.data_available" :isArray="Array.isArray(startup.data_available)"/>

                      <StartupInfoLine :noCutter='true' v-if="startup.regulatory_status" name="regulatory_status" :value="startup.regulatory_status"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.patents" name="Patents granted/applied" :value="startup.patents"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.other_protections" name="Other forms of protection" :value="startup.other_protections"/>


                      <StartupInfoLine :noCutter='true' v-if="startup.sustainability_impact" name="Sustainability impact" :value="startup.sustainability_impact" :isArray="Array.isArray(startup.sustainability_impact)"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.key_benefits" name="Key benefits" :value="startup.key_benefits" :isArray="Array.isArray(startup.key_benefits)"/>

                      <StartupInfoLine :noCutter='true' v-if="startup.key_benefits_kpi" name="Solution's KPIs" :value="startup.key_benefits_kpi" />
                      <StartupInfoLine :noCutter='true' v-if="startup.pitchdeck_link" name="Link to presentation deck" :value="startup.pitchdeck_link" :isUrl="true"/>

                      <StartupInfoLine :noCutter='true' v-if="startup.presentation_deck_file" name="Presentation deck file" :value="this.apiUrl+'/get_public_file/'+startup.presentation_deck_file._id.$oid" displayedAs="View presentation deck file" :isUrl="true"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.TRL" name="TRL" :value="startup.TRL"/>


                    </div>
                  </div>
                </v-window-item>




                <v-window-item value="traction">
                  <button type="button" name="button" class="editContact" @click="showEditModal('traction')">
                    <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>

                  </button>
                  <div class="row padding20 insideTab">
                    <div class="grid">
                      <StartupInfoLine :noCutter='true' v-if="startup.development_stage" name="Development stage" :value="startup.development_stage"/>

                    </div>
                  </div>
                </v-window-item>



                <v-window-item value="goals">
                  <button type="button" name="button" class="editContact" @click="showEditModal('goals')">
                    <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>

                  </button>
                  <div class="row padding20 insideTab">
                    <div class="grid">
                      <StartupInfoLine :noCutter='true' v-if="startup.partnership_objectives" name="partnership objectives" :value="startup.partnership_objectives" :isArray="Array.isArray(startup.partnership_objectives)"/>
                      <StartupInfoLine :noCutter='true' v-if="startup.additional_info" name="Additional Information " :value="startup.additional_info" />

                    </div>
                  </div>
                </v-window-item>
              </v-window>
              </div>
          </div>


        <div class="step_footer mt50" >
          <div class="errors" v-if='errors'>
              <div class="alert alert-danger listIt">

                  <span v-for='(e,i) in errors' :key="i"> {{e.$message}}</span>
              </div>
          </div>
          <div class="row row_center mt50" >
            <div class="col-12 text-right">
                 <!-- <button type="button"  class="next_step_btn" @click="save" name="button">Save</button> -->
                 <button type="button"  class="next_step_btn" @click="submit" v-if="startup.partial" name="button">Submit</button>
                 <button type="button"  class="next_step_btn" @click="save" v-if="!startup.partial" name="button">Save</button>

                 <!-- <button type="button" class="next_step_btn" v-if="step < 4" @click="stepPlus()" name="button">Next</button> -->
               </div>
             </div>
        </div>




      <!-- <div class="footer" style="">
      <small><a href="https://www.innopearl.ch/data-policy/" target="_blank">Data policy</a> - Powered by Innopearl</small>
      </div>
     -->

<div class="footer">
  <small><a href="https://www.innopearl.ch/data-policy/" target="_blank">Data policy</a></small>

  <small class="footerAbs2">Powered by <span class="tblue">Innopearl © 2024</span></small></div>

    </div>

    </div>



  </div>
</template>

<script>
// import StartupInfoLine from '@/components/InfoStartupLine.vue'
import { nextTick } from 'vue';
import { toast } from 'vue-sonner'

// import _ from 'lodash';
// import AddFounderModal from '@/components/modals/addFounder.vue'
import countries from '@/assets/db_coutries.json';
// import Treeselect from 'vue3-treeselect'
// import FileUploader from '@/components/FileUploaderPitchDeck.vue';
// // import the styles
import AddComment from '@/components/modals/addCommentStartup.vue'
import { useVuelidate } from '@vuelidate/core'
import { required,maxLength,helpers,email,maxValue,minValue } from '@vuelidate/validators'

import ConnectedSoonModal from '@/components/modals/ConnectedSoonModal.vue'
import StartupInfoLine from '@/components/InfoStartupLine.vue'
import ConnectedOkModal from '@/components/modals/ConnectedOkModal.vue'

import UpdateNonStartup from '@/components/modals/UpdateNonStartup.vue'

import 'vue3-treeselect/dist/vue3-treeselect.css'
export default {
  name : "ProfileNonStartup",
  components: {
    // AddFounderModal,
    ConnectedSoonModal,
    ConnectedOkModal,

    StartupInfoLine,
    UpdateNonStartup,
    // Treeselect,
    // FileUploader,
    AddComment
    // StartupInfoLine,
  },
  props: {
    initialStartup: { type: Object, required: true },
    showGlobal: Boolean,
  },
  setup () {
   return { u$: useVuelidate() }
  },
  validations () {
   return {
     startup:{
       name: {
         required :helpers.withMessage('Innovator name is required.', required),
       },
       TRL: {  /* eslint-disable */
         maxValue: helpers.withMessage(
             ({
               $pending,
               $invalid,
               $params,
               $model
             }) => `Max value is 9.`,
             maxValue(9)
           ),
           minValue: helpers.withMessage(
               ({
                 $pending,
                 $invalid,
                 $params,
                 $model
               }) => `Min value is 1.`,
               minValue(1)
             ),
               /* eslint-enable */
       },
       website: {
         required :helpers.withMessage('Please provide a website.', required),
       },

      location:{
        required :helpers.withMessage('Please provide where you are based.', required),
      },

      key_contact_name:{
        required :helpers.withMessage('Please provide a name for your key contact.', required),
      },
      key_contact_email:{
        required :helpers.withMessage('Please provide an email for your key contact.', required),
        email : helpers.withMessage('Please provide a valid email address for key contact.', email),
      },
      key_contact_phone:{
        required :helpers.withMessage('Please provide a phone number for your key contact.', required),
      },


      value_proposition:{
        required :helpers.withMessage('Please pitch your company.', required),
              /* eslint-disable */
        maxLength:helpers.withMessage(
            ({
              $pending,
              $invalid,
              $params,
              $model
            }) => `Please pitch your company in less than ${$params.max} characters.`,
            maxLength(700)
          )
                /* eslint-enable */
      },
      solution:{
        required :helpers.withMessage('Please tell us more about your solution.', required),
              /* eslint-disable */
        maxLength:helpers.withMessage(
            ({
              $pending,
              $invalid,
              $params,
              $model
            }) => `Please describe your solution in less than ${$params.max} characters.`,
            maxLength(700)
          )
                /* eslint-enable */
      },
      product_category:{
        required :helpers.withMessage('Innovation category is required.', required),
        /* eslint-disable */
        maxLength:helpers.withMessage(
            ({
              $pending,
              $invalid,
              $params,
              $model
            }) => `Please select up to ${$params.max} innovation categories.`,
            maxLength(5)
          )
          /* eslint-enable */
      },
      innovation_area:{
        required :helpers.withMessage('Innovation area is required.', required),
        /* eslint-disable */
        maxLength:helpers.withMessage(
            ({
              $pending,
              $invalid,
              $params,
              $model
            }) => `Please select up to ${$params.max} innovation areas.`,
            maxLength(5)
          )
          /* eslint-enable */
      },
      IP:{
        required :helpers.withMessage('Please provide what type of IP you have.', required),
      },
      application_area:{
        required :helpers.withMessage('Please provide the main application domains of your solution.', required),
          /* eslint-disable */
            maxLength:helpers.withMessage(
            ({
              $pending,
              $invalid,
              $params,
              $model
            }) => `Please select up to ${$params.max} application domains.`,
            maxLength(5)
          )
                    /* eslint-enable */
      },
      key_benefits:{
         required :helpers.withMessage('Please provide the benefits of your solution for consumers or customer.', required),
      },
      development_stage:{
        required :helpers.withMessage("Please provide  your innovation's development stage.", required),
      },



     }

   }
 },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      pageInfo: {
        mainTitle : "Your innovator profile ",
        subTitle : "",
      },
      tab: null,
      errors:false,
      file: null,
      chunks: [],
      chunksBanner: [],
      chunksLogo: [],
      uploaded: 0,
      uploadProceed: false,
      uploadProceedBanner: false,
      uploadProceedLogo:false,
      addedFile: null,
      submitOK: false,
      partner_client_name: null,
      showSubmitModal:false,
      showSoonModal: false,
      showConnectedOKModal:false,
      what :'',
      dialog: {
        summary_update: false,
      },
      dict: {
        innovation_areas: [],
        development_stage: [],
        ip: [],
        location: countries,
        funding_stage: [],
        product_category: [],
        business_model: [],
        key_benefits: [],
        application_areas: [],
        market_fit_evidence: [],
        markets: [],
        type_of_assets:[],
        segments: [],
        skills: [],
        sustainability_impact: [],
        partnership_objectives:[],
        data_available: [],
        company_type: [],
      },
      bindProps: {
        mode: "international",
        defaultCountry: "FR",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: "Enter a phone number",
        required: false,
        enabledCountryCode: true,
        enabledFlags: true,
        preferredCountries: ["FR", "CH","US",'ES',"IT","GB",'NL'],
        wrapperClasses: "",
      },
      startup : this.initialStartup
    }
  },
  computed:{
    website_formated: function(){
      if(this.startup.website){
        console.log(this.startup.website);
        if(String(this.startup.website).startsWith("https://")){
          return this.startup.website;
        }
        else{
          return "https://"+this.startup.website;
        }
      }
      else{
        return null;
      }

    },
    startup_image: function(){
      if(this.startup.image){
        console.log(this.startup.image);
        return this.startup.image.$oid;
      }
      else{
        return null;
      }

    },
    startup_logo: function(){
      if(this.startup.logo){
        console.log(this.startup.logo);
        return this.startup.logo.$oid;
      }
      else{
        return null;
      }

    },
    progress() {
      if(this.file){
          return Math.floor((this.uploaded * 100) / this.file.size);
      }
      else{return 0;}

    },
    formData() {
        let formData = new FormData;
        formData.set('imageTargetDBField', 'banner');
        formData.set('is_last', this.chunksBanner.length === 1);
        formData.set('file', this.chunksBanner[0], `${this.file.name}.part`);
        formData.set('file_extension_original', this.file.name.split('.').pop());
        formData.set('startup', this.startup._id.$oid);
        formData.set('fileType', "banner");
        return formData;
    },
    formDataLogo() {
        let formData = new FormData;
        formData.set('imageTargetDBField', "logo");
        formData.set('is_last', this.chunksLogo.length === 1);
        formData.set('file', this.chunksLogo[0], `${this.file.name}.part`);
        formData.set('file_extension_original', this.file.name.split('.').pop());
        formData.set('startup', this.startup._id.$oid);
        formData.set('fileType', "logo");
        return formData;
    },
    config() {
        return {
            method: 'POST',
            data: this.formData,
            url: this.apiUrl+'/upload_public_image',
          //  url: this.apiUrl+'/restrict/test_upload_startup/649c14ec4df341c71a0a5d03',

            headers: {
                'Content-Type': 'application/octet-stream'
            },
            onUploadProgress: event => {
                this.uploaded += event.loaded;
            }
        };
    },
    configLogo() {
        return {
            method: 'POST',
            data: this.formDataLogo,
            url: this.apiUrl+'/upload_public_image',
          //  url: this.apiUrl+'/restrict/test_upload_startup/649c14ec4df341c71a0a5d03',

            headers: {
                'Content-Type': 'application/octet-stream'
            },
            onUploadProgress: event => {
                this.uploaded += event.loaded;
            }
        };
    }

  },
  methods:{
    confirmEdit(v){
      console.log(v);
      console.log(this.backup_startup);
      if(v?.company_type == this.backup_startup?.company_type){
        this.startup = v;
        this.dialog.summary_update = false;
      }
      else{
        this.$router.go(this.$router.currentRoute);
      }

      //this.startup = v;
      //this.$router.go(this.$router.currentRoute);
    },
    data_policy_start(){
      this.showSoonModal = false;
        this.showEditModal('global');
    },
    showEditModal(modal){
      if(modal == "summary"){
        this.what = "summary";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }

      else if(modal == "contact"){
        this.what = "contact";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "global"){
        this.what = "global";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "needhelp"){
        this.what = "needhelp";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "solution"){
        this.what = "solution";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "capabilities"){
        this.what = "capabilities";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "contacts"){
        this.what = "contacts";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "goals"){
        this.what = "goals";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "traction"){
        this.what = "traction";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "company"){
        this.what = "company";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      console.log(this.backup_startup);
    },
    closeAndReset(){
      this.dialog.summary_update = false;
      this.startup = this.backup_startup;
    },
    isThereFounders(f){
      if(f == null){
        return false;
      }
      else if(f.length > 0){
        return true;
      }
      else{
        return false;
      }
    },
    founderLink: function(link){
      if(link){
        if(link.startsWith("https://")){
          return link;
        }
        else{
          return "https://"+link;
        }
      }
      else{
        return null;
      }

    },
    getBaseUrl(u){
      if(u){
        var formated = String(u).replace(/^https?:\/\//, '').replace(/\/$/, '');
        try{
          var r= new URL(u).origin;
          r = r.replace(/^https?:\/\//, '').replace(/\/$/, '');
          return r;
        }catch{
          return formated;
        }
      }
      else{
        return "";
      }

    },
    gobackrouter : function(){
      this.$router.go(-1);
    },

    async validator(){
      const isFormCorrect = await this.u$.startup.$validate()
      console.log(isFormCorrect);
      if(!isFormCorrect){
        toast.error("Your profile contains errors. Please check your input")
      }
    },
    save(){
      console.log(this.startup);
      this.axios.post(process.env.VUE_APP_API_URL+"/public_startup_save/"+this.startup._id.$oid,
        this.startup,
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        this.startup.lastEditDate = r.data;
        toast.success("Your profile has been updated and submitted")
      }).catch( (e) => {
        console.log(e);
      toast.error("Sorry an error occurs !")
      });
    },
    async submit(){
        this.errors = false;
        this.u$.startup.$touch()
        var isFormNotCorrect = this.u$.startup.$invalid;
        console.log("isFormCorrect",isFormNotCorrect);
        console.log("errror",this.u$.$errors);


        if(isFormNotCorrect){
          this.errors = this.u$.startup.$errors;
          toast.error("Your profile contains errors.",{
            description:"Please correct your entries"
          });
          this.showSubmitModal = false;
        }
        else{
          this.realSubmit("");
        }
        console.log(isFormNotCorrect);
      },
    realSubmit(v){
        if(this.startup.website){
          this.startup.website = this.startup.website.toLowerCase();
        }
      //   // ADD VALIDATOR FOR MANDATORY FIELDS
        if(v)this.startup.comment_to_innopearl = v;
        else this.startup.comment_to_innopearl = "";
        this.axios.post(process.env.VUE_APP_API_URL+"/public_startup_submit_v2/"+this.startup._id.$oid,
          this.startup,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Innovator profile submitted successfully.")
          // this.$router.push('/expert/startup_info/'+this.startup._id.$oid);
          this.submitOK = true;
          this.startup.partial = false;
          this.showSubmitModal = false;
          this.showConnectedOKModal = true;
        }).catch( (e) => {
          console.log(e);
          this.showSubmitModal = false;
          toast.error("Sorry an error occurs !")
        });
       //}

    },

    imageChange(val){
      if(val){
        this.startup.image = val;
      }
    },
    logoChange(val){
      if(val){
        this.startup.logo = val;
      }
    },


        selectBanner(event) {
          this.uploaded = 0;
            this.file = event.target.files.item(0);
            this.createChunks();
            this.uploadProceedBanner = true;
            // console.log(this.chunks);
            // this.upload();
        },
        selectLogo(event) {
          this.uploaded = 0;
            this.file = event.target.files.item(0);
            this.createChunksLogo();
            this.uploadProceedLogo = true;
            // console.log(this.chunks);
            // this.upload();
        },
        upload() {
            this.axios(this.config).then((r) => {
              console.log(r);
              this.chunksBanner.shift();
              if(r.data)if(r.data)this.addedFile = r.data;
            }).catch(error => {console.log(error);this.uploadProceed = false;toast.error("Error during upload");});
        },
        uploadLogo() {
            this.axios(this.configLogo).then((r) => {
              console.log(r);
              this.chunksLogo.shift();
              if(r.data)if(r.data)this.addedFile = r.data;
            }).catch(error => {console.log(error);this.uploadProceed = false;toast.error("Error during upload");});
        },
        createChunks() {
            let size = 8192, chunks = Math.ceil(this.file.size / size);

            for (let i = 0; i < chunks; i++) {
                this.chunksBanner.push(this.file.slice(
                    i * size, Math.min(i * size + size, this.file.size), this.file.type
                ));
            }
        },
        createChunksLogo() {
            let size = 8192, chunks = Math.ceil(this.file.size / size);

            for (let i = 0; i < chunks; i++) {
                this.chunksLogo.push(this.file.slice(
                    i * size, Math.min(i * size + size, this.file.size), this.file.type
                ));
            }
        }
  },
  mounted(){
    this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
    console.log(this.$route.params.id);
    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_partnership_objectives_startup").then( (r) => {
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.partnership_objectives = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });
    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_skills").then( (r) => {
          console.log("INNOV AREA");
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.skills = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });

    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_sustainability_impact").then( (r) => {
          console.log("sustainability_impact");
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.sustainability_impact = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });
    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_product_category").then( (r) => {
          console.log("INNOV AREA");
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.product_category = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });
    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_markets").then( (r) => {
          console.log("INNOV AREA");
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.markets = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });
    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_data_available").then( (r) => {
          console.log("INNOV AREA");
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.data_available = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });
    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_company_type").then( (r) => {
          console.log("INNOV AREA");
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.company_type = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });
    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_type_of_assets").then( (r) => {
          console.log("INNOV AREA");
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.type_of_assets = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });


    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_segments").then( (r) => {
          console.log("INNOV AREA");
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.segments = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });
    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_market_fit_evidence").then( (r) => {
          console.log("INNOV AREA");
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.market_fit_evidence = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });
    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_key_benefits").then( (r) => {
          console.log("INNOV AREA");
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.key_benefits = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });
    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_application_areas").then( (r) => {
          console.log("INNOV AREA");
      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.application_areas = r.data
  this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_innovation_areas").then( (r) => {
        console.log("INNOV AREA");
    console.log(r);
    r.data.forEach((item) => {
      delete item["_id"];
      delete item["customer"];
        delete item["ordre"];
    });
    this.dict.innovation_areas = r.data
  }).catch( (e) => {
  if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
  else toast.error("Oops! Something went wrong")
  });
    this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_development_stage").then( (r) => {

      console.log(r);
      r.data.forEach((item) => {
        delete item["_id"];
        delete item["customer"];
          delete item["ordre"];
      });
      this.dict.development_stage = r.data
      this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_ip").then( (r) => {
        console.log("IP");
        console.log(r);
        r.data.forEach((item) => {
          delete item["_id"];
          delete item["customer"];
          delete item["ordre"];
        });

        this.dict.ip = r.data
      }).catch( (e) => {
      if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
      else toast.error("Oops! Something went wrong")
      });
      this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_funding_stage").then( (r) => {
        console.log(r);
        r.data.forEach((item) => {
          delete item["_id"];
          delete item["customer"];
            delete item["ordre"];
        });

        this.dict.funding_stage = r.data
        this.axios.get(process.env.VUE_APP_API_URL+"/dict/dict_business_model").then( (r) => {
          console.log(r);
          r.data.forEach((item) => {
            delete item["_id"];
            delete item["customer"];
              delete item["ordre"];
          });

          this.dict.business_model = r.data
        }).catch( (e) => {
        if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
        else toast.error("Oops! Something went wrong")
        });
      }).catch( (e) => {
      if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
      else toast.error("Oops! Something went wrong")
      });

    }).catch( (e) => {


    if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
    else toast.error("Oops! Something went wrong")
    });

  }).catch( (e) => {


  if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
  else toast.error("Oops! Something went wrong")
  });

  if(this.showGlobal == true){
    this.showEditModal('global');
  }



},
watch: {
  dialogVisible: function(){
    this.startup = this.s;
    this.step = 1;
    nextTick(() => {
      this.resize('value_proposition');
      this.resize('solution');
    });
  },
  showGlobal: function(v){
    console.log("showGlobal watcher = "+v);
    if(v)this.showEditModal('global');
  },
  chunksLogo: {
    handler(val) {
      if (val.length > 0) {
             this.uploadLogo();
      }
      else{
        this.uploadProceedLogo = false;
        this.logoChange(this.addedFile);

      }
    },
    deep: true
  },

  chunksBanner: {
    handler(val) {
      if (val.length > 0) {
             this.upload();
      }
      else{
        this.uploadProceedBanner = false;
        this.imageChange(this.addedFile);

      }
    },
    deep: true
  },
}
}
</script>

<style lang="css" scoped>
.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  padding-bottom:20px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-bottom-left-radius: 8px;
border-bottom-right-radius: 8px;
position:relative;
}

.needHelp{
  position:absolute;
  top:20px;
  right:50px;
  color:#B38D2F;
  cursor: pointer;
  border:1px solid #B38D2F;
  border-radius:20px;
  padding: 5px 20px;
  display:inline-block;
}

@media screen and (max-width:690px){
  .needHelp{
    position:relative;
    top:auto;
    right:auto;
    color:#B38D2F;
    margin-bottom:25px;
  }

}
.startup_name{
  color: #3783C5;
text-transform: uppercase;
font-size:24px;
line-height: 29px;
}
.startup_website{
margin-top: 10px;

}
.startup_website a{
  font-size:16px;
  line-height: 22px;
  text-decoration: none;
  color: #000;

}
.startup_website img{
  margin-right: 10px;
}
.startup_banner{

  position:relative;
  height:300px;
  background:#fff;
  padding: 0 !important;
}
.startup_banner img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.changeImage{
  position:absolute;
  top:15px;
  right:30px;
  font-size:12px;
  line-height: 12px;
  color:#000;
  background:#FFF;
  border-radius:50%;;
  padding: 10px;

}
.changeImageLogo{
  position:absolute;
  top:0px;
  right:0px;
  font-size:12px;
  line-height: 12px;
  color:#000;
  background:#FFF;
  border-radius:50%;;
  padding: 10px;

}
.assessment{
  margin-top:100px;
  margin-bottom: 100px;
}
.item_card{
  border: 1px solid #DDD;
  border-radius: 10px;
padding: 20px;
position:relative;
padding-top: 40px;
margin-top: 20px;
}
.item_card .item_card_title{
  position:absolute;
  top: 0px;
  transform: translateY(-50%);
  left: 20px;
  background: #FFF;
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 24px;
  padding-left: 20px;
  padding-right: 20px;
}






.barcontainer{
  background-color: #DDDDDD;
  position: relative;
  margin-left: 50px;
  width: 30px;
  height: 200px;
}
.bar{
  background-color: #3783C5;
  position: absolute;
  bottom: 0;
  width: 100%;

  box-sizing: border-box;
  -webkit-transition: all 0.5s linear;
      -moz-transition: all 0.5s linear;
      -o-transition: all 0.5s linear;
      transition: all 0.5s linear;
  transform-origin: bottom;
}
.bar.low{
  height: 10%;
}
.bar.medium{
  height: 50%;
}

.bar.high{
  height: 90%;

}

@keyframes grow{
  from{
    transform: scaleY(0);
  }
}

.jauge_label.low{
  position: absolute;
  bottom :10%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label.medium{
  position: absolute;
  bottom :50%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}


.jauge_label.high{
  position: absolute;
  top :10%;
  transform: translateY(-50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label::before{
  content :" ";
  background: #707070;
  width:10px;
  height:1px;
  left: -10px;
  position:absolute;
  top: 50%;
}
.jauge_label input{
  width:22px;
  height:22px;
}

.jauge_label span{
  display:block;
  color: #3783C5;
  font-size: 14px;
  line-height: 22px;
  width:100%;
  font-weight: 500;
  text-transform:uppercase;
}
.jauge_label small{
  color: #575757;
  font-weight: 300;
  font-size:14px;
  line-height: 22px;
}
.info{
    display: flex;
    flex-direction: column;
    padding: 5px;
}

.flex{
  display:flex;
  align-items: center;
    gap: 20px;
}
.barLabel{
  color: #3783C5;
  font-size:18px;
  line-height: 21px;
}
@media screen and (max-width:1200px){
  .flex{
    flex-direction: column;

    align-items: flex-start;
  }
}

.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}

.center{
  align-items: center;
}

.mt50{
  margin-top: 50px;
}
.mb50{
  margin-bottom: 50px;
}

.divider-dotted{
  border-bottom:1px dashed #3783C5;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;

}
.next_step_btn img.left{
  margin-right:10px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
  margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}

.prev_step_btn{
  text-decoration :none;
}
.contact_step_btn{
  border: 1px solid #575757;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  background:#575757;
  margin:5px;
  text-decoration: none;
}

@media screen and (max-width: 690px){
  .startup_page{
    padding-left:15px;
    padding-right: 15px;
  }
  .content_div{
    padding-right: 20px;
    padding-left: 20px;
  }
}



.info_startup{
  display:flex;
gap: 10px;
/* border-bottom: 1px solid #DDD; */
padding-bottom: 10px;
padding-top: 10px;
flex-direction: column;
}


.info_startup_1{
  width: 100%;
  display:flex;
  flex-direction: column;
}
.info_startup_2{
  width: 100%;
  display:block;
}

.fullW .info_startup_1{
    width: 50%;
  }
.fullW .info_startup_2{
    width: 50%;
      display:block;
}
.info_startup.large_col1 .info_startup_1,
.info_startup.large_col1 .info_startup_2{
  width:50%;
    display:block;
}

@media screen and (max-width: 690px){
  .info_startup{
    flex-direction: column;
  }
  .info_startup_1,
  .info_startup_2{
    width:100%;
      display:block;
  }
}
.info_startup_1 .info_name{
font-size: 12px;
line-height: 15px;
color: #000;
text-transform: uppercase;
font-weight: 700;
}
.info_startup_1 .info_name.innopearl_purple{
  color: #6C68A2;
}
.info_startup_2 .info_value{
  font-size:16px;
  line-height: 22px;
  width: 100%;
  resize-x:none;
}

.startup_founders{
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 0px;
}
.founder{
  font-size: 16px;
  line-height: 28px;
  margin-left:0px;
  padding-left:0px;
}
.founder .picto_link_linkedin{
  margin-left:20px;
}
.info_value{
white-space: pre-wrap
}

.info_value_investment{
  width:auto !important;
  display:inline-block;
  max-width: 100px;
}

.selectDevise{
  border:1px solid #CCC;
  -webkit-appearance: auto;
  -moz-appearance :auto;
  padding:5px;
  max-width: 50px;
}

input,textarea{
  border-bottom: 1px solid #B38D2F;
  padding:5px;
}

.add_custom_key_factor button{
  font-size:12px;
  color:#FFF;
  background: #3783C5;
  border-radius:200px;
  padding:5px 10px;
}
button.error{
  background: red;
  padding:5px;
  width:25px;
  height:25px;
  font-size:15px;
  line-height: 15px;
  border-radius:50%;
  color:#FFF;
}
.add_founder{
  margin-top:10px;
}

.selectDevise{
  -moz-appearance: button;
  padding: 5px;
  max-width: 50px;
  border-bottom: 1px solid #B38D2F;
  font-size: 16px;
  line-height: 22px;
  margin-left: 5px;
}

.jauge_label{
  text-align:left !important;
}

.padding20{
  padding:20px;
}





.bussiness_challenge_stepper{
  display: flex;
  gap: 20px;
  justify-content: center;

}
.bussiness_challenge_stepper .step{
  border-bottom: 1px solid #ADB3B5;
  position : relative;
  flex: 1;
  text-align: center;
  padding: 10px;
}
.bussiness_challenge_stepper .step.active{
    border-bottom: 2px solid #3783C5;
}
.bussiness_challenge_stepper .active:after{
  content: '';
position: absolute;
left: calc(50% - 15px);
top: 100%;
width: 0;
height: 0;
border-left: 15px solid transparent;
border-right: 15px solid transparent;
border-top: 15px solid #3783C5;
clear: both;
}
.bussiness_challenge_stepper .stepNumber{
  font-size: 36px;
  line-height: 44px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.bussiness_challenge_stepper .stepName{
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.bussiness_challenge_stepper .active .stepNumber,
.bussiness_challenge_stepper .active .stepName
{
  color: #3783C5;
}
.ptb50{
  padding-top:50px;
  padding-bottom: 50px;
}

.rowinside{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap:20px;
  justify-content: center;
  align-items: flex-start;
    align-self: flex-start;
    align-content: flex-start;
}

.col-in{
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-left:20px;
  padding-right: 20px;
  justify-content: center;
}

textarea{
  width:100% !important;
}

.requi{
  font-size:20px;
  color:red;
}
sup{
  top:0 !important;
}

.table_brief_doc thead td{
  background: #EEE;
  padding-top:10px;
  padding-bottom:10px;
}
.table_brief_doc tbody{
  border:1px solid #EEE;
}
.table_brief_doc a{
  color: inherit;
}
.table_brief_doc svg{
  color: #3783C5
}



.zone_input_checkboxes{
  margin-left: 65px;
  width: calc(100% - 65px);
  display: flex;
  margin-top:20px;
  gap: 20px;
  flex-wrap: wrap;
}

.partnership_objectives_label{
  padding:12px 30px;
  background: #EFEFEF 0% 0% no-repeat padding-box;
border-radius: 3px;
min-width: calc(20% - 20px);
max-width: calc(20% - 20px);
flex-basis: 0;
flex: 1;
display:flex;
flex-direction: column;
gap: 10px;
border: 1px solid #EFEFEF;
}

@media screen and (max-width: 990px){
  .partnership_objectives_label{
    min-width: calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
}

@media screen and (max-width: 690px){
  .partnership_objectives_label{
    min-width: calc(100% - 20px);
    max-width: calc(100% - 20px);
  }
}
input[type='checkbox']{
  width: 24px;
height: 24px;
margin-top:auto;
}
.checkbox_container{
  width:100%;
  display:block;
  text-align: right;
  align-self: end;
margin-top: auto;
}
.partnership_objectives_label.add_other_objectif{
background:#FFF;
}
.add_other_objectif input{
  border:1px solid #EFEFEF;
  padding: 5px;
}
.checkbox_container button{
  font-size: 18px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
}

.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}


.checkbox-wrapper-21 .control {
  display: block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 18px;
}
.checkbox-wrapper-21 .control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.checkbox-wrapper-21 .control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 25px;
  width: 25px;
  background: #FFF;
  border:1px solid #3783C5;
}
.checkbox-wrapper-21 .control:hover input ~ .control__indicator,
.checkbox-wrapper-21 .control input:focus ~ .control__indicator {
  background: #FFF;
}
.checkbox-wrapper-21 .control input:checked ~ .control__indicator {
  background: #3783C5;
}
.checkbox-wrapper-21 .control:hover input:not([disabled]):checked ~ .control__indicator,
.checkbox-wrapper-21 .control input:checked:focus ~ .control__indicator {
  background: #3783C5;
}
.checkbox-wrapper-21 .control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.checkbox-wrapper-21 .control__indicator:after {
  content: '';
  position: absolute;
  display: none;
}
.checkbox-wrapper-21 .control input:checked ~ .control__indicator:after {
  display: block;
}
.checkbox-wrapper-21 .control--checkbox .control__indicator:after {
  left: 10px;
    top: 5px;
    width: 7px;
    height: 12px;
    border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.checkbox-wrapper-21 .control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}

.successMessage{
  padding:50px;
  border:2px solid #3783C5;
}
.successMessage .thankyou1{
  display:block;
  text-align: center;
  font-size:25px;
  text-transform: uppercase;
  color:#3783C5;
  font-weight: 700;
}

.successMessage .thankyou2{
  display:block;
  text-align: center;
  font-size:20px;
  text-transform: uppercase;
  color:#3783C5;
}


.dflex{
  display:flex;
  justify-content: flex-start;
}
.has-addons{
  display: flex;
  gap: 0;
  border: 1px solid #CCC;
  border-radius: 20px;
}
#copyToClipboard{
  background: #3783C5;
  color: #FFF;
  padding: 15px 20px;
  border-radius: 0px 20px 20px 0px;
    cursor:pointer;
}
#copyToClipboardContent{
padding: 10px;
cursor:pointer;

}

#copyToClipboardContent input{
  width: auto;
  display: block;
  cursor:pointer;
  border:none;
  min-width: 450px;
}


.footer{
  margin-top:40px;
  padding:10px;text-align:center;
}
.footer small{
  display:block;
}
.footer a{
  color:inherit;
}

  .footerAbs2{
    position:absolute;
    bottom:28px;
    right:20px;
  }

  @media screen and (max-width:990px){
    .footerAbs2{
      position:relative;
      bottom:auto;
      right:auto;
    }
  }
.headerStartup{
  position:relative;
}
.mt100{
  padding-top:120px;
}
.startup_logo{
  width: 300px;
    height: 150px;
    position: absolute;
    left: 50px;
    bottom: -75px;
    z-index: 999;

}
.startup_logo img{
  width: 300px;
    height: 150px;
    object-fit: contain;
    padding:10px;
}
.startup_logo .alt{
  width: 300px;
    height: 150px;

}
.startup_logo_inside{
  position:relative;
  -webkit-box-shadow: 0px 0px 20px -4px #CCC;
  box-shadow:0px 0px 20px -4px #CCC;
  background:#FFF;
}

.partialInfo{
  position: absolute;
  top: 0;
  background: #B38D2F;
  color: #FFF;
  z-index: 900;
  padding: 10px 20px;
  left: 50%;
  transform: translateX(-50%);
  max-width:80%;
  font-size:20px;
  text-align:center;
}

.tblue{
    color: #4C81C0 !important;
}
.tdore{
  color: #B38D2F !important;
}
.contactZone{
  border:2px solid #125AA4;
  background:#125AA4;
  border-radius: 10px;
  padding:20px 20px;
  width:auto;
  position:relative;
}
.editContact{
  position:absolute;
  top:10px;
  right:10px;
}
@media screen and (max-width:1000px){
  .contactZone{
    margin-top:20px;
  }
}
.contactZone h5{
  display: block;
  color: #fff !important;
  margin-bottom: 0;
  font-size:22px;
}
.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #fff !important;
  font-weight: 600;
}

.contactInfo{
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #000 !important;
  font-weight: 600;
}

.contactInfo a,
.contactInfo a:hover{
  color: #000 !important;
  font-weight: normal;
word-wrap: anywhere;
}

.editField{
  color:#000;
  margin-left:10px;
}

.grid{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap : 10px 20px;
}

@media screen and (max-width:990px){

  .grid{
    display:grid;
    grid-template-columns: 1fr;
    gap : 10px 20px;
  }
}

.insideTab{
  min-height:100px;
}

.listIt{
  display:flex;
  flex-direction: column;
}

.startup_banner .fallbackBanner{
  width: 100%;
  height: 100%;
  background:#EFEFEF;
}

#bannerUp{
  display: none;
}

#logoUp{
  display: none;
}

.uploadProceedBanner{
  position: absolute;
    top: 0;
    left: 0;
    transform: none;
    background: rgba(255,255,255,0.9);
    padding: 20px;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-content: center;
}
.uploadProceedBanner .uploadProcess{
  width:80%;
}


.pl20{
  padding-left:20px !important;
}
@media screen and (max-width:890px){
.listOfContacts .respTable{
  flex-direction: column;
  display:flex;
  border-bottom:1px solid #000;
}

.listOfContacts .respTable .text-right{
  text-align:left !important;
}
.listOfContacts td{
  border:none;
}
}

.fallbackBanner_size{
  font-size: 40px;
  color: #CCC;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.fs30{
  font-size:30px;
}

.contactInfoItem{
  color:#B38D2F !important;
}
.contactInfoItem a,
.contactInfoItem a:hover,
.contactInfoItem span
{
  color:#FFF !important;
}
.contactInfo_kcn{
  color:#FFF;
  font-weight: 600;
    font-size:18px;
}

.contactInfoItem{
  margin-bottom: 10px;
}
.mb20{
  margin-bottom: 20px;
}

.contactZone .editContact{
  color:#FFF !important;
}

.dflexcontact{
  display:flex;
  gap:10px;
  align-items: center;
}

.contactIcon i{
  font-size: 30px;
    background: #3584C6;
    padding: 25px;
    color: #FFF;
    border-radius: 50%;
}
.contactInfoItem *{
  word-break:break-all;
}

.fblue{
  background: #3584C6;
    padding: 15px;
    color: #FFF;
    border-radius: 50%;
    margin-right: 10px;
    font-size: 15px;

}
.cmail a,
.cmail a:hover,
.ctel a,
.ctel a:hover{
    color:inherit;
}
.cmail i{
font-size:25px;
border-radius: 50%;
  margin-right: 10px;
}
.mr20{
      margin-right: 10px;
}
.crole{
  margin-left:20px;
}

.clinks{
  display:flex;
  gap:10px;
  justify-content: end;
}

.clinks i{

    background: #fff;
    border:1px solid #3584C6;
      padding: 15px;
      color: #3584C6;
      border-radius: 50%;
      font-size: 20px;


}

@media screen and (min-width:1200px) and (max-width:1700px){
  .force50{
    width:50% !important;
  }
}
@media screen and (max-width:1500px){
  .force100{
    margin-top:60px;
    width:100% !important;
  }
  .revese{
  flex-direction: column-reverse;
  }

}

.cn,
.ctel,
.cmail{
  width:30%;
}

@media screen and (max-width:1500px){
.respTable{
  display:flex;
  flex-direction: column;

}
.respTable td{
  width:100%;
  border:none;
}
.clinks{
  display:flex;
  gap:10px;
}
.respTable td:last-child{
  border-bottom:1px solid #ccc;
}
}

.listOfContacts{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
.listOfContacts .contactZone{
  width:calc(33% - 40px);
}

@media screen and (max-width:1500px){
  .listOfContacts .contactZone{
    width:calc(50% - 40px);
  }
}
@media screen and (max-width:990px){
  .listOfContacts .contactZone{
    width:100%;
  }
}
</style>
<style media="screen">
  .v-window{
    border: 1px solid #3783C5;
    margin-bottom:50px;
  }
  .v-tabs{
        background: #115AA4 !important;

  }
  .v-tab--selected{
    background: #3783C5 !important;
  }
  .v-tab__slider{
    display:none;
  }
  .vue-treeselect__menu{
    height:150px !important;
  }
</style>
